const namedSizes = {
  default: { bg: 'Стандартна', en: 'Standard' },
  chocolate: { bg: 'С шоколад', en: 'With chocolate' },
  jam: { bg: 'Със сладко', en: 'With jam' },
  honey: { bg: 'С мед', en: 'With honey' },
  cheese: { bg: 'Със сирене', en: 'With cheese' }
};

const unitLabels = {
  'мл': { bg: 'мл', en: 'ml' },
  ml: { bg: 'мл', en: 'ml' },
  'л': { bg: 'л', en: 'L' },
  l: { bg: 'л', en: 'L' },
  'г': { bg: 'г', en: 'g' },
  g: { bg: 'г', en: 'g' },
  'кг': { bg: 'кг', en: 'kg' },
  kg: { bg: 'кг', en: 'kg' },
  'см': { bg: 'см', en: 'cm' },
  cm: { bg: 'см', en: 'cm' }
};

export const formatMeasure = (value, language = 'bg') => {
  const rawValue = String(value ?? '').trim();
  const namedSize = namedSizes[rawValue];

  if (namedSize) return namedSize[language] || namedSize.en;

  const pieceMatch = rawValue.match(/^(\d+(?:\.\d+)?)(?:бр|pcs?|pieces?)\.?$/i);
  if (pieceMatch) {
    const amount = Number(pieceMatch[1]);
    if (language === 'bg') return `${pieceMatch[1]} бр.`;
    return `${pieceMatch[1]} ${amount === 1 ? 'pc.' : 'pcs.'}`;
  }

  const measureMatch = rawValue.match(/^(\d+(?:\.\d+)?)(мл|ml|л|l|г|g|кг|kg|см|cm)$/i);
  if (measureMatch) {
    const unit = unitLabels[measureMatch[2].toLowerCase()];
    return `${measureMatch[1]} ${unit?.[language] || measureMatch[2]}`;
  }

  return rawValue;
};
